import { api } from '../api/client';

export type MaintenanceReview = {
  programId: string;
  name: string;
  /** Null when it has never been practised since reaching the maintenance list. */
  daysSinceLast: number | null;
  daysChecked: number;
  intervalDays: number;
  due: boolean;
};

export type MaintenanceList = {
  /** False when the account has not switched review reminders on. */
  on: boolean;
  dueCount: number;
  programs: MaintenanceReview[];
};

/**
 * Which mastered programs are ready to be looked at again.
 *
 * Returns null rather than throwing: this decorates a page that has to work without it, so a
 * failure here should cost the markers, not the programs beside them.
 */
export async function fetchMaintenance(learnerId: string | null): Promise<MaintenanceList | null> {
  try {
    return await api<MaintenanceList>(
      learnerId ? `/maintenance?learnerId=${encodeURIComponent(learnerId)}` : '/maintenance',
      { token: true },
    );
  } catch {
    return null;
  }
}
